import React from "react";

import { useCategoryCardContext } from "../DashboardCards";

import FullWidth from "./Templates/FullWidth";
import Generic from "./Templates/Generic";

const CategoryCard = () => {
  const { fullWidth } = useCategoryCardContext();

  if (fullWidth) return <FullWidth />;
  return <Generic />;
};

export default CategoryCard;
